module.exports = __webpack_public_path__ + "static/media/02.7def4c54.jpg";